import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { DadosNotaFiscal, TipoEntrega } from "app/types/pesquisa-orcamento/consultas/NotasFiscais";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { NotasFiscais } from "./NotasFiscais";
import { useMenuSubConsultasNotaFiscal } from "../menu-sub-consultas-nota-fiscal/useMenuSubConsultasNotaFiscal";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { useMenuConsultasPesquisaOrcamento } from "../menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";

export type NotaFiscalContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onVoltar: () => void,
    onRemover?: () => boolean
    passos: Dict<string, () => void>,
};

export const NotasFiscaisContainer = (props: NotaFiscalContainerProps) => {
    const [dados, setDados] = useState<DadosNotaFiscal[]>([]);
    const [entregas, setEntregas] = useState<TipoEntrega[]>([]);
    const [mostrarDetalhesTipoEntrega, setMostrarDetalhesTipoEntrega] = useState(false);
    const [notaFiscalSelecionada, setNotaFiscalSelecionada] = useState<Partial<DadosNotaFiscal>>(null)

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDadosNotasFiscais = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.NotaFiscalSaida.ListarNotasFiscais(
                props.orcamentoSelecionado.NumeroPedido
            );

            if (("Error" in resultado)) {
                onVoltar();
                return
            }

            setDados(resultado.NotasFiscais);
            setEntregas(resultado.TipoEntrega);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onSelecionarMostrarTipoEntrega = (mostrar: boolean, notaFiscal: DadosNotaFiscal) => {
        setMostrarDetalhesTipoEntrega(mostrar)
        setNotaFiscalSelecionada(notaFiscal)
    }

    const onRenderizarNotasFiscais = () => renderizarComponentReact(
        <NotasFiscaisContainer {...props} />, "pesquisar-pedidos-region", true
    )

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onMostrarImagem = async (numord: number) => {
        const resultado = await microuniversoApi.NotaFiscalSaida.ObterImagemCanhotoNotaFiscal(
            numord
        );
        
        const imageUrl = URL.createObjectURL(resultado);
        $(".notafiscalcanhoto").lightGallery({
            dynamic: true,
            dynamicEl: [{
                src: imageUrl,
            }]

        });
    }

    useMenuSubConsultasNotaFiscal({
        notaFiscalSelecionada: notaFiscalSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onVoltar: () => onRenderizarNotasFiscais(),
        passos: passosInterno.current
    })

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.map)),
    })

    useEffect(() => {
        passosInterno.current.set("Notas Fiscais", () => { })
        onObterDadosNotasFiscais();
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="NotasFiscaisContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <NotasFiscais
                orcamentoSelecionado={props.orcamentoSelecionado}
                entregas={entregas}
                notasFiscais={dados}
                mostrarDetalhesTipoEntrega={mostrarDetalhesTipoEntrega}
                notaFiscalSelecionada={notaFiscalSelecionada}
                onSelecionarMostrarTipoEntrega={onSelecionarMostrarTipoEntrega}
                onMostrarImagem={onMostrarImagem}
            />
        </>
    );
}
